import { render } from "./Sale_Receipts.vue?vue&type=template&id=59f92c90&scoped=true"
import script from "./Sale_Receipts.vue?vue&type=script&lang=js"
export * from "./Sale_Receipts.vue?vue&type=script&lang=js"

import "./Sale_Receipts.vue?vue&type=style&index=0&id=59f92c90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f92c90"]])

export default __exports__